import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import CountUp from "react-countup";
import { baseurl } from "../Baseurl";
import { useNavigate } from "react-router-dom";
import BArchart from "./BArchart";
import Agechart from "../Component/service/Agechart";
import Patientbarchart from "../Pages/Patientbarchart";
import Appointmnetgraph from "./Appointmentgrph";
import Imcoechart from "./Imcoechart";
import MonthlyIncomeGraph from "./MonthlyIncomeGraph";
import DashboardInsights from "./DashboardInsights";
import WeeklyInsights from "./WeeklyInsights";
import WaitingTimeChart from "./WaitingTimeChart";
import { hasPermission } from "../utils/permissions";
export default function Dashboard() {
  const [data, setData] = useState([]);
  const [ICD, setICD] = useState([]);
  const [services, setServices] = useState([]);
  const [services1, setServices1] = useState([]);
  const [services2, setServices2] = useState([]);
  const navigate = useNavigate();

  // Track permissions for dashboard cards
  const [permissions, setPermissions] = useState({
    patients: true,
    appointments: true,
    billing: true,
  });

  // Check permissions on mount
  useEffect(() => {
    const checkPermissions = async () => {
      const patientsAccess = await hasPermission("/Admin/patient");
      const appointmentsAccess = await hasPermission("/Admin/appointment2");
      const billingAccess = await hasPermission("/Admin/Billing");

      setPermissions({
        patients: patientsAccess,
        appointments: appointmentsAccess,
        billing: billingAccess,
      });
    };
    checkPermissions();
  }, []);

  // Handle navigation with permission check
  const handleNavigate = async (path) => {
    const hasAccess = await hasPermission(path);
    if (hasAccess) {
      navigate(path);
    } else {
      alert("You don't have permission to access this module.");
    }
  };
  useEffect(() => {
    getDatasetAtEv();
  }, []);
  const getDatasetAtEv = async () => {
    try {
      const response = await axiosInstance.get(`dashboard`);
      if (response.status === 200) {
        setData(response.data.data);
      } else {
        console.error("Unexpected status:", response.status);
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };
  useEffect(() => {
    getdata1();
  }, []);
  const getdata1 = async () => {
    try {
      const response = await axiosInstance.get(`getAllPatientsPaymentSummary`);
      if (response.data) {
        setServices1(response.data.data);
      } else {
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };
  useEffect(() => {
    getdata();
  }, []);
  const getdata = async () => {
    const response = await axiosInstance.get(`dashboard/top_services`);
    if (response.data) {
      setServices(response.data.services);
    } else {
    }
  };
  useEffect(() => {
    getdata2();
  }, []);
  const getdata2 = async () => {
    const response = await axiosInstance.get(
      `dashboard/top_doctors_byAppointments`
    );
    if (response.data) {
      setServices2(response.data.data);
    } else {
    }
  };
  useEffect(() => {
    ICD1();
  }, []);
  const ICD1 = async () => {
    const response = await axiosInstance.get(
      `dashboard/getTop_ICD_Diagnoses`
    );
    if (response.data) {
      setICD(response.data.diagnoses);
    } else {
    }
  };
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  const sortedServices = [...services1].sort(
    (a, b) => b.pending_balance - a.pending_balance
  );

  //Calculate total pending balance
  const totalPending = sortedServices.reduce(
    (acc, item) => acc + Number(item.pending_balance || 0),
    0
  );
  return (
    <div className="pc-container">
      <div className="pc-content">

        {/* ── Row 1: KPI Summary Cards (compact) ──────────────────────── */}
        <div className="row g-2 mb-3">

          {/* Patients */}
          <div className="col-6 col-md-4 col-xl compactStatCol">
            <div
              className="card h-100 compactStatCard"
              onClick={() => permissions.patients && navigate("/Admin/patient")}
              style={{ cursor: permissions.patients ? "pointer" : "default" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <div className="avtar avtar-s bg-light-primary flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="compactStatLabel">All Patients</div>
                    <div className="compactStatValue text-primary"><CountUp end={data.totalPatients} /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Appointments */}
          <div className="col-6 col-md-4 col-xl compactStatCol">
            <div
              className="card h-100 compactStatCard"
              onClick={() => permissions.appointments && navigate("/Admin/appointment2")}
              style={{ cursor: permissions.appointments ? "pointer" : "default" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <div className="avtar avtar-s orangeBgDash flex-shrink-0">
                    <svg fill="none" height="18" width="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z" stroke="#e58a00" strokeWidth="1.5"></path>
                      <path d="M7 4V2.5" stroke="#e58a00" strokeWidth="1.5" strokeLinecap="round"></path>
                      <path d="M17 4V2.5" stroke="#e58a00" strokeWidth="1.5" strokeLinecap="round"></path>
                      <path d="M2.5 9H21.5" stroke="#e58a00" strokeWidth="1.5" strokeLinecap="round"></path>
                    </svg>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="compactStatLabel">Appointments</div>
                    <div className="compactStatValue text-warning"><CountUp end={data?.totalAppointments} /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Payments */}
          <div className="col-6 col-md-4 col-xl compactStatCol">
            <div
              className="card h-100 compactStatCard"
              onClick={() => permissions.billing && navigate("/Admin/Billing")}
              style={{ cursor: permissions.billing ? "pointer" : "default" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <div className="avtar avtar-s bg-light-success flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490.9 490.9" width="18" height="18" fill="currentColor">
                      <path d="M81.7,273.2c-6.6,0-12,5.4-12,12s5.4,12,12,12h46.1c6.6,0,12-5.4,12-12s-5.4-12-12-12H81.7z"></path>
                      <path d="M283.8,297.2h46.1c6.6,0,12-5.4,12-12s-5.4-12-12-12h-46.1c-6.6,0-12,5.4-12,12S277.2,297.2,283.8,297.2z"></path>
                      <path d="M458.4,78.2h-349c-17.9,0-32.5,14.6-32.5,32.5v47.1H24c-13.2,0-24,10.8-24,24v206.9c0,13.2,10.8,24,24,24h366 c13.2,0,24-10.8,24-24v-55.6h44.4c17.9,0,32.5-14.6,32.5-32.5v-190C490.8,92.7,476.3,78.2,458.4,78.2z M322.8,181.8 c2.7,36,31.3,64.8,67.2,67.9v71.8c-36,2.7-64.8,31.3-67.9,67.2H91.2c-2.7-36-31.3-64.8-67.2-67.9V249c36-2.7,64.8-31.3,67.9-67.2 L322.8,181.8L322.8,181.8z M346.8,181.8h43.1v43.8C367.3,222.6,349.4,204.5,346.8,181.8z M67.7,181.8c-2.9,22.6-21,40.6-43.8,43.1 v-43.1H67.7z M24,344.9c22.6,2.9,40.6,21,43.1,43.8H24V344.9z M346.2,388.6c2.9-22.6,21-40.6,43.8-43.1v43.1H346.2z M466.8,300.6 c0,4.7-3.8,8.5-8.5,8.5h-44.4V181.8c0-13.2-10.8-24-24-24H100.8v-47.1c0-4.7,3.8-8.5,8.5-8.5h349c4.7,0,8.5,3.8,8.5,8.5V300.6z"></path>
                    </svg>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="compactStatLabel">Total Payments</div>
                    {(() => {
                      const value = data?.totalPayments?.value ?? 0;
                      const formatted = formatter.format(value);
                      const [integer, decimal] = formatted.split(".");
                      return (
                        <div className="compactStatValue text-success">
                          {integer}{decimal && <span className="compactStatDecimal">.{decimal}</span>}
                          <span className="compactStatUnit">BHD</span>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Invoice */}
          <div className="col-6 col-md-4 col-xl compactStatCol">
            <div
              className="card h-100 compactStatCard"
              onClick={() => permissions.billing && navigate("/Admin/Billing")}
              style={{ cursor: permissions.billing ? "pointer" : "default" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <div className="avtar avtar-s bg-light-danger flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                      <path d="M14 2v5h5" />
                      <path d="M9 13h6M9 17h4M9 9h2" />
                    </svg>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="compactStatLabel">Invoice</div>
                    {(() => {
                      const value = data?.totalInvoices?.value ?? 0;
                      const formatted = formatter.format(value);
                      const [integer, decimal] = formatted.split(".");
                      return (
                        <div className="compactStatValue text-danger">
                          {integer}{decimal && <span className="compactStatDecimal">.{decimal}</span>}
                          <span className="compactStatUnit">BHD</span>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Average Spend Per Visit */}
          <div className="col-6 col-md-4 col-xl compactStatCol">
            <div
              className="card h-100 compactStatCard"
              onClick={() => permissions.billing && navigate("/Admin/Billing")}
              style={{ cursor: permissions.billing ? "pointer" : "default" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center gap-2">
                  <div className="avtar avtar-s bg-light-info flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="12" y1="1" x2="12" y2="23"></line>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="compactStatLabel">Avg. Spend / Visit</div>
                    {(() => {
                      const appointmentsCount = Number(data?.totalAppointments) || 0;
                      const paymentsValue = Number(data?.totalPayments?.value) || 0;
                      const avg = appointmentsCount > 0 ? paymentsValue / appointmentsCount : 0;
                      const formatted = formatter.format(avg);
                      const [integer, decimal] = formatted.split(".");
                      return (
                        <div className="compactStatValue text-info">
                          {integer}{decimal && <span className="compactStatDecimal">.{decimal}</span>}
                          <span className="compactStatUnit">BHD</span>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* ── Row 2a: AI Insights & Predictions ─────────────────────────── */}
        <div className="row g-3 mb-3">
          <div className="col-12 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-bulb me-2" style={{ color: "#6f42c1" }} />
                  AI Insights &amp; Predictions
                </h5>
              </div>
              <DashboardInsights />
            </div>
          </div>
        </div>

        {/* ── Row 2b: Primary Charts ─────────────────────────────────────── */}
        <div className="row g-3 mb-3">
          <div className="col-12 col-md-6 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-calendar-stats me-2" style={{ color: "#4680ff" }} />
                  Monthly Visits
                </h5>
              </div>
              <Appointmnetgraph />
              <WeeklyInsights endpoint="dashboard/appointments_graph_daily" kind="visits" color="primary" />
            </div>
          </div>
          <div className="col-12 col-md-6 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-chart-line me-2" style={{ color: "#2ca87f" }} />
                  Income Chart
                </h5>
              </div>
              <MonthlyIncomeGraph />
              <WeeklyInsights endpoint="dashboard/payments_graph_daily" kind="income" color="success" />
            </div>
          </div>
        </div>

        {/* ── Row 3: Demographics + Payment Channels ───────────────────── */}
        <div className="row g-3 mb-3">
          <div className="col-12 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-users me-2" style={{ color: "#ff4c97" }} />
                  Patients Gender
                </h5>
              </div>
              <div className="card-body">
                <Agechart />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-chart-bar me-2" style={{ color: "#e58a00" }} />
                  Patients Age
                </h5>
              </div>
              <div className="card-body">
                <Patientbarchart />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-xl-6 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-credit-card me-2" style={{ color: "#17a2b8" }} />
                  Payment Channels
                </h5>
              </div>
              <Imcoechart />
            </div>
          </div>
        </div>

        {/* ── Row 4: Data Lists ─────────────────────────────────────────── */}
        <div className="row g-3 mb-3">
          <div className="col-6 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100 compactListCard">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-stethoscope me-2" style={{ color: "#d93d3e" }} />
                  Frequent Diagnosis
                </h5>
              </div>
              <ul className="list-group list-group-flush topDiagnosis">
                {ICD && ICD.length > 0 && ICD.map((item, index) => (
                  <li key={index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-center gap-2">
                      <div className="minw0">
                        <p className="mb-0 truncate">{item?.code}</p>
                        <p className="text-muted mb-0 truncate"><small>{item?.name}</small></p>
                      </div>
                      <div className="text-end d-flex align-items-center flex-shrink-0">
                        <div className="badgeTop">{item?.count}</div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100 compactListCard">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-user-star me-2" style={{ color: "#4680ff" }} />
                  Top Doctors
                </h5>
              </div>
              <ul className="list-group list-group-flush topDiagnosis">
                {services2 && services2.length > 0 && services2.map((item, index) => (
                  <li key={index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-center gap-2">
                      <div className="minw0">
                        <p className="mb-0 truncate">{item?.doctorName}</p>
                        <p className="text-muted mb-0 truncate"><small>{item?.specialty}</small></p>
                      </div>
                      <div className="text-end d-flex align-items-center flex-shrink-0">
                        <div className="badgeTop">{item?.appointmentCount}</div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-6 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100 projectAble compactListCard">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-alert-circle me-2" style={{ color: "#d93d3e" }} />
                  Pending Balance ({totalPending.toFixed(3)}) BHD
                </h5>
              </div>
              <div className="card-body p-2">
                <div className="d-grid topDiagnosis">
                  {services1 && services1.length > 0 &&
                    [...services1]
                      .filter(item => Number(item.pending_balance) > 0)
                      .sort((a, b) => b.pending_balance - a.pending_balance)
                      .map((item, index) => (
                        <div key={index} className="btn btn-link-secondary">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center minw0">
                              <div className="p-1 d-block bg-warning rounded-circle me-2 flex-shrink-0"></div>
                              <p className="mb-0 text-start truncate">{item.patient_name}</p>
                            </div>
                            <p className="text-success mb-0 flex-shrink-0">BHD {item?.pending_balance}</p>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-xl-3 dashboardCard">
            <div className="cardBorder h-100 projectAble compactListCard">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-list-check me-2" style={{ color: "#2ca87f" }} />
                  Top Services
                </h5>
              </div>
              <div className="card-body p-2">
                <div className="d-grid topDiagnosis">
                  {services && services.length > 0 && services.map((item, index) => (
                    <div key={index} className="btn btn-link-secondary">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center minw0">
                          <div className="p-1 d-block bg-warning rounded-circle me-2 flex-shrink-0"></div>
                          <p className="mb-0 truncate" title={item.serviceName}>{item.serviceName}</p>
                        </div>
                        <div className="text-end flex-shrink-0">
                          <div className="badgeTop">{item?.usageCount}</div>
                          <p className="text-success mb-0">BHD {item?.totalValue}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Row 5: Analysis Charts ────────────────────────────────────── */}
        <div className="row g-3">
          <div className="col-12 col-md-6 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-flask me-2" style={{ color: "#6f42c1" }} />
                  Total Labs Request
                </h5>
              </div>
              <BArchart />
            </div>
          </div>
          <div className="col-12 col-md-6 dashboardCard">
            <div className="cardBorder h-100">
              <div className="tableHeader">
                <h5 className="mb-0">
                  <i className="ti ti-speakerphone me-2" style={{ color: "#fb8c00" }} />
                  Waiting Times Tracker
                </h5>
                <span style={{ fontSize: 11, color: "#9aa0ac" }}>Last 7 days · min</span>
              </div>
              <WaitingTimeChart />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
